module.exports = __webpack_public_path__ + "static/media/instagram.26e33b26.svg";